export default "__VITE_ASSET__0CL7cGiO__"